export default __webpack_public_path__ + "static/media/tooltip_icon.91c23b53.svg";